import * as React from 'react';
import { CommunityRequest } from '@shapeable/types';

export const CommunityRequestsContext = React.createContext<CommunityRequest[]>([]);
export const CommunityRequestsProvider = CommunityRequestsContext.Provider;